import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { i18n } from '@/plugins/i18n'
import vuetify from './plugins/vuetify'
import Vuelidate from 'vuelidate'
import VuetifyMask from "vuetify-mask";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { showError } from './plugins/errors';
import VCurrencyField from 'v-currency-field';
import { VTextField } from 'vuetify/lib';
import IdleVue from 'idle-vue';
import SlideUpDown from 'vue-slide-up-down';

Vue.prototype.$showError = showError
Vue.use(VuetifyMask);
Vue.use(Vuelidate);
Vue.use(Toast, {
  position: "top-right",
  timeout: 15000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
  rtl: false
})
Vue.component('v-text-field', VTextField);
Vue.component('slide-up-down', SlideUpDown);
Vue.use(VCurrencyField, {
  locale: 'pt-BR',
  decimalLength: 2,
  autoDecimalMode: false,
  appendIcon: true,
  defaultValue: null,
  valueAsInteger: false,
  allowNegative: false,
});

Vue.config.productionTip = false;

const app = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')

Vue.use(IdleVue, {
  eventEmitter: app,
  idleTime: 20 * 60 * 1000
})
